import React, { useCallback, useEffect, useState } from 'react';
// Types
import { SalesOrderProps } from 'types/salesOrder';
// Utils
import { delay, useSetState, validArray } from 'utils';
import { sortByDate } from 'utils/events'
// App Context
// import { useAppDispatch } from 'context/AppContext';
// Sales Order Context
import { useSalesOrderDispatch, useSalesOrderState } from 'context/SalesOrderContext';
import * as salesFlags from 'context/SalesOrderContext/statusFlags';
import { setSalesOrderFilters } from 'context/SalesOrderContext/actions';
// Assets
import Icon from 'assets/Icon';
// Elements
import Alert from 'elements/Alert';
import Button from 'elements/Button';
import { Loading } from 'elements/Loading';
// Global Components
import PageHeader from 'components/PageHeader';
// Components
import SalesOrder from './components/SalesOrder';
import SalesOrderFilterBar from './components/SalesOrderFilterBar';
// Styles
import styles from './style/sales.module.css';

function Sales() {
  // Sales State
  const { salesOrderFilters } = useSalesOrderState()
  const salesOrderDispatch = useSalesOrderDispatch();
  const { salesOrder, salesState, noMoreSalesOrder } = useSalesOrderState();
  // State
  const initialState = {
    loading: true,
    // resendEvents: [],
  }
  const [state, setState] = useSetState(initialState);
  const [disabled, setDisabled] = useState(false);

  const loadingData = (
    salesState === salesFlags.GET_SALES_ORDER
      || salesState === salesFlags.RESOLVE_SALES_ORDER
      || salesState === salesFlags.RESEND_SALES_ORDER
  );
  /* const eventPatchSuccess = (
    salesState === salesFlags.RESEND_SALES_ORDER_SUCCESS
      || salesState === salesFlags.RESOLVE_SALES_ORDER_SUCCESS
  ); */

  const initiatePage = useCallback(async () => {
    await delay(200);
    setState({ loading: false });
  }, [setState]);

  function renderEvents(event:SalesOrderProps) {
    return (
      <SalesOrder
        event={event}
        key={event.orderInfo.orderId}
      />
    )
  }

  async function handleNext() {
    setDisabled(true);
    setState({ offSet : Number(state.offSet) + 10 });
    salesOrderDispatch(setSalesOrderFilters({ ...salesOrderFilters, offSet : Number(salesOrderFilters.offSet) + 10 }));
  }

  /* useEffect(() => {
    if (eventPatchSuccess) {
      setState({ resendEvents: [] });
    }
  }, [eventPatchSuccess, salesState, setState]);

  useEffect(() => {
    setState({ resendEvents: [] })
  }, [salesOrderFilters, setState]); */

  useEffect(() => {
    initiatePage();
  }, [initiatePage])

  
  return (
    <>
      <PageHeader heading="View Sales Orders" />
      <SalesOrderFilterBar setDisabled={setDisabled} />
      <section className="wrapper">
        <div className={`wrapper__content ${styles.container}`}>
          { state.loading || (loadingData && salesOrderFilters.offSet === 0)  ? (
            <div className={`${styles.loading} ${styles.grid}`}>
              {[...Array(8)].map((e, i) => <span key={i.toString()} />)}
            </div>
          ) : (
            <>
              {salesOrder && salesOrder.length > 0 ? (
                <div className={styles.grid}>
                  {validArray(salesOrder) && salesOrder.sort(sortByDate).map(renderEvents)}
                </div>
              ) : (
                <Alert active={true} type="info" label="No sales order Found" />
              )}
            </>
          )}
        </div>  
      </section>
      <div className={styles.seeMore}>
        {disabled ?
          <Button btnStyle="secondary" btnType="icon" label="loading">
            <Loading fill="white" size={32} />
          </Button>
          : null }
        { !disabled && noMoreSalesOrder && salesOrder.length > 0 ?
          <Button
            btnSize="small"
            btnType="iconBefore"
            elevation="2-4"
            disabled={disabled}
            handler={() => handleNext()}
          > 
            <Icon
              icon="ExpandMore"
            />
            See More
          </Button> : null}
      </div>
    </>
  );
}

export default Sales;
